import { productTypesInversed } from '@teinor/erp/types/company/product'
import { OrderData } from '../../../../specificComponents/inputTableLayouts/order/OrderLayout/types'
import { TwinDictionary } from '../../dictionary'
import { RowData } from '../../../../baseComponents/TwinTable/types'
import { TwinTranslationTF } from '../../../hooks/useTwinTranslation'
import { OrderUniqueNumber } from '@teinor/erp/types/company/order/general'

export const checkUniqueNumberComplete= (allRowData: RowData) => {
    if (!allRowData || !allRowData.unique_number){
        return false
    } else if (allRowData.BuyDeliveryNoteId && allRowData.BuyInvoiceId) {
        return true
    }
    const productType = allRowData['productType']
    const isSerialized = productType === productTypesInversed['serialized']
    const isLot = productType === productTypesInversed['lots']
    const quantity = parseFloat(allRowData.quantity)
    if(isSerialized){
        return checkUniqueNumber(allRowData.unique_number, quantity)
    }else if(isLot){
        return checkLotUniqueNumber(allRowData.unique_number, parseFloat(allRowData.quantity))
    }
    return true

}
const checkUniqueNumber= (unique_number: OrderUniqueNumber[], quantity: number) => {
    const match: {[serialCode: string]: number[]} = {}
    const err = []
    let totalQuantity = 0
    for (const key in unique_number) {
        const myUniqueNumber = unique_number[key]
        const serialCode = myUniqueNumber.serialCode
        totalQuantity += parseFloat(String(myUniqueNumber.quantity || 1))
        const keyParsed = parseInt(key)
        if(!match[serialCode]){
            match[serialCode] = []
        }else{
            err.push(keyParsed)
        }
        match[serialCode].push(keyParsed)
    }
    if (err.length || totalQuantity !== parseFloat(String(quantity))){
        return false
    }
    return true
}

const checkLotUniqueNumber = (unique_number: TwinDictionary, quantity: number) => {
    const match: {[serialCode: string]: number[]} = {}
    const err = []
    let totalQuantity: number = 0
    for (const key in unique_number) {
        const serialCode = unique_number[key].serialCode
        const quantityUniqueNumber = unique_number[key].quantity
        totalQuantity += parseFloat(String(quantityUniqueNumber))
        const keyParsed = parseInt(key)
        if(!match[serialCode]){
            match[serialCode] = []
        }else{
            err.push(keyParsed)
        }
        match[serialCode].push(keyParsed)
    }
    if (err.length || totalQuantity !== quantity){
        return false
    }
    return true
}
export const checkIfOrderIsOkForSend = (completeData: OrderData | null, t: TwinTranslationTF) => {
    if (!completeData?.originalTableData.length) {
        return false
    }
    if (checkIfUniqueNumbersAreOkey(completeData, t)){
        return false
    }
    return true
}
export const checkIfSerialNumberAndIsProcessed = (allRowData: RowData) => {
    let isProcessed = false
    const isSerializedAndHaveDeliveryNote = allRowData.productType === productTypesInversed['serialized'] && allRowData.BuyDeliveryNoteId
    const inDeliveryNoteFinal = !allRowData.BuyInvoiceId && allRowData.desiredQuantity
    const isInvoice = allRowData.BuyInvoiceId
    if (isSerializedAndHaveDeliveryNote && (inDeliveryNoteFinal || isInvoice)) {
        isProcessed = true
    }
    return isProcessed
}
export const checkIfUniqueNumberAndIsProcessed = (allRowData: RowData) => {
    let isProcessed = false
    const isSerializedOrLotAndHaveDeliveryNote = (allRowData.productType === productTypesInversed['serialized'] || allRowData.productType === productTypesInversed['lots'])&& allRowData.BuyDeliveryNoteId
    const inDeliveryNoteFinal = !allRowData.BuyInvoiceId && allRowData.desiredQuantity
    const isInvoice = allRowData.BuyInvoiceId
    if (isSerializedOrLotAndHaveDeliveryNote && (inDeliveryNoteFinal || isInvoice)) {
        isProcessed = true
    }
    return isProcessed
}

const checkLineUniqueNumberIsOkey = (t: TwinTranslationTF, line: { [fieldName: string]: any }): string | null => {
    const productType = line['productType']
    const isSerialized = productType === productTypesInversed['serialized']
    const isLot = productType === productTypesInversed['lots']
    let correct = true
    if (isLot || isSerialized) {
        correct = checkUniqueNumberComplete(line)
        if (!correct) {
            return t('errorInUniqueNumberOrLot','Hay un problema con un producto serializado o un lote')
        }
    }
    return null
}

export const checkIfUniqueNumbersAreOkey = (completeData: OrderData | null, t: TwinTranslationTF) => {
    const lines = completeData?.tableData
    if (lines) {
        for (const line of lines) {
            const checkedLine = checkLineUniqueNumberIsOkey(t, line)
            if(checkedLine){
                return checkedLine
            }
        }
    }
    return null
}

export const checkIfSelectedProductsAreOkForSend = (selectedProducts: TwinDictionary[]) => {
    let result = true
    for (const line of selectedProducts) {
        result = checkSellLineUniqueNumberIsOkey(line, result)
        if(result === false){
            return result
        }
    }
    return result
}

const checkSellLineUniqueNumberIsOkey = (line: { [fieldName: string]: any }, result: boolean) => {
    const productType = line['productType']
    const isSerialized = productType === productTypesInversed['serialized']
    const isLot = productType === productTypesInversed['lots']
    let correct = true
    if (isLot || isSerialized) {
        correct = checkUniqueNumberComplete(line)
        if (!correct) {
            result = false
        }
    }
    return result
}